const getState = state => state.calendar

export const getSyncingInProgress = state => getState(state).syncingInProgress
export const getIsSynced = state => getState(state).isSynced
export const getItems = state => getState(state).items
export const getPrimaryProvider = state => getState(state).primaryProvider
export const getProfileName = state => getState(state).profileName
